import axios from 'utils/axios'
import { VENUE_ID } from 'utils/env'

export const fetchRevenueCentersList = () =>
  axios.get(`/operator/ordering_board/orders_by_state.json?venue_uuid=${VENUE_ID}`)

export const fetchRevenueCenterOrders = id =>
  axios.get('/operator/ordering_board/orders_by_state.json', {
    params: {
      venue_uuid: VENUE_ID,
      revenue_center_uuid: id,
    },
  })

export default {
  fetchRevenueCenterOrders,
  fetchRevenueCentersList,
}
